export default __webpack_public_path__ + "message.949bcea721879be21296beafda3dca5c.svg";